// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://hdrwukecsqdxpnzfmmeb.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imhkcnd1a2Vjc3FkeHBuemZtbWViIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTEwMzA3NjEsImV4cCI6MjA2NjYwNjc2MX0.hrz1gbGerqC1YHPfb9tjMoF-z2XP8M96TVkJi9e66kU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);